export class DomData {
    public static getProviderName(): string {
        return this.getRichContentElement()?.dataset.provider ?? 'missing';
    }

    public static getModuleCount(): number {
        return this.getRichContentElement()?.querySelectorAll('.js_rc_teaser')?.length ?? 0;
    }

    public static getOtherProviderNames(): string[] {
        return (
            this.getRichContentElement()
                ?.dataset.otherProviders?.trim()
                .split('|')
                .filter((s) => s) ?? []
        );
    }

    private static getRichContentElement() {
        return document.querySelector<HTMLElement>('.js_rc_component');
    }
}
